/** @namespace app */
import "./App.less";
import React, {lazy, Suspense} from "react";
import FeedLayout from "./FeedLayout";
import {Route, Switch} from "wouter";
import Login from "@web/page/Login";
import SignUp from "@web/page/SignUp";
import {useAuthOven} from "@web/hooks/useAuthOven";
import {auth} from "@web/lib/firebase";
import {UserContext, LinesContext, SourcesContext, PayContext} from "@web/hooks/context";
import Loading from "@web/components/Loading";
import {RequireAuth} from "@web/ui/containers/RequireAuth";
import OauthCallback from "@web/page/OauthCallback";
import VerifyEmailLink from "@web/page/VerifyEmailLink";
import {Alert} from "antd";
import TrelloAuthCallback from "@web/components/TrelloAuthCallback";
import VideoModal from "@web/components/VideoModal";
import Home from "@web/page/Home";
import PhoneAuth from "@web/components/PhoneAuth";
import {getServices, getSolutions} from "./dashboard.config";
import AuthLayoutWrapper from "@web/components/AuthLayoutWrapper";
import {useDispatch} from "react-redux";
import WildcardRoute from "@web/components/WildcardRoute";
import ProductsPage from "@web/page/ProductsPage";
// import collectionActions from '@web/redux/collections/actions';
// import collectionsActions from '@web/redux/collections/actions';

// const appKey = process.env.REACT_APP_OVEN_APP_ID;
// const configKey = appKey?.replace(/-/g, "_");
// const About = lazy(() => import("@web/page/About"));
const AccountPage = lazy(() => import("@web/page/AccountPage"));
const TimelineSettingsPage = lazy(() => import("@web/page/TimelineSettingsPage"));
const LinePage = lazy(() => import("@web/page/LinePage"));
// const MessengerPage = lazy(() => import("@web/page/MessengerPage"));
// const AppsPage = lazy(() => import("@web/page/AppsPage"));
const LineOnboarding = lazy(() => import("@web/page/LineOnboarding"));
// const ActivityPage = lazy(() => import("@web/page/ActivityPage"));
const Splash = lazy(() => import("@web/components/Splash"));
const AuthEmailPage = lazy(() => import("@web/page/EmailAuthPage"));
// const ProOnboarding = lazy(() => import("@web/components/onboarding/ProOnboarding"));
const Pay = lazy(() => import("@web/page/Pay"));
const Paid = lazy(() => import("@web/components/Paid"));
const Logout = lazy(() => import("@web/page/Logout"));
// const WorkflowEditor = lazy(() => import("@web/components/WorkflowEditor"));
// const Io = lazy(() => import("@web/page/Io"));
const LandingPage = lazy(() => import("@web/page/LandingPage"));
// const AppStore = lazy(() => import("@web/page/AppStore"));

const solutions = getSolutions();
const services = getServices();

const App = () => {
  /** @type {useAuthOvenData} */
  const [
    user,
    claims,
    loadingUser,
    errorLoadingUser,
  ] = useAuthOven(auth);

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (!user?.uid) {
      return;
    }

    // todo - temp code until we have a dynamic way to handle base paths
    dispatch({
      type: "SET_BASE_PATH",
      basePath: "user/" + user.uid,
    });

    if (claims?.data?._h) {
      dispatch({type: "SYNC_LINES"});
      dispatch({type: "INITIALIZE/COLLECTIONS"});
      // dispatch(collectionActions.syncCollection(true, "collections"));
      // dispatch({type: "SYNC_USER_COLLECTION", collectionId: "apps"});
      // dispatch({type: "SYNC_USER_COLLECTION", collectionId: "sandbox"});
    }
  }, [dispatch, user?.uid, claims.data?._h]);

  if (loadingUser) {
    return <Loading />;
  }

  if (errorLoadingUser) {
    return <Alert
      type="warning"
      banner
      message="Please refresh or try again later"
      description="TheScribe is currently unavailable."
    />;
  }

  console.log("App: user", claims, user);
  // if (!claims?.data) {
  //   return <Loading />;
  // }

  return <UserContext.Provider value={[user?.uid, claims?.data?._h, user, claims, []]}>
    <SourcesContext.Provider value={{services, solutions}}>
    <FeedLayout>
      <Switch>
        <Route path="/">
          <Home />
        </Route>
        <Route path="/creators">
          <Suspense fallback={<Loading />}>
            <LandingPage />
          </Suspense>
        </Route>
        <Route path="/plans/creators">
          <RequireAuth allowAnonymous>
            <Suspense fallback={<Loading />}>
              <ProductsPage plan="creators" />
            </Suspense>
          </RequireAuth>
        </Route>
        <Route path="/plans/creators/confirm">
          <RequireAuth allowAnonymous>
            <Suspense fallback={<Loading />}>
              <ProductsPage plan="creators" confirm />
            </Suspense>
          </RequireAuth>
        </Route>
        {/*<Route path="/apps">*/}
        {/*  <LinesContext.Provider value={{}}>*/}
        {/*    <RequireAuth allowAnonymous>*/}
        {/*      <Suspense fallback={<Loading/>}>*/}
        {/*        <LinePage />*/}
        {/*      </Suspense>*/}
        {/*    </RequireAuth>*/}
        {/*  </LinesContext.Provider>*/}
        {/*</Route>*/}
        {/*<Route path="/app-store">*/}
        {/*  <Suspense fallback={<Loading />}>*/}
        {/*    <LinePage />*/}
        {/*    /!*<AppStore />*!/*/}
        {/*  </Suspense>*/}
        {/*</Route>*/}
        {/*<Route path="/app-store">*/}
        {/*  <LinesContext.Provider value={{serviceId: "app-store", view: "table"}}>*/}
        {/*    <RequireAuth allowAnonymous={true}>*/}
        {/*      <Suspense fallback={<Loading/>}>*/}
        {/*        <LinePage />*/}
        {/*      </Suspense>*/}
        {/*    </RequireAuth>*/}
        {/*  </LinesContext.Provider>*/}
        {/*</Route>*/}
        {/*<Route path="/apps/create">*/}
        {/*  <LinesContext.Provider value={{serviceId: "create", view: "application"}}>*/}
        {/*    <RequireAuth allowAnonymous={true}>*/}
        {/*      <Suspense fallback={<Loading/>}>*/}
        {/*        <LinePage />*/}
        {/*      </Suspense>*/}
        {/*    </RequireAuth>*/}
        {/*  </LinesContext.Provider>*/}
        {/*</Route>*/}
        <Route path="collection/apps/install/:appId">
          {(params) =>
            <LinesContext.Provider
              value={{
                ...params,
                collectionId: "app",
                basePath: `user/${user?.uid}`,
                view: "install",
              }}
            >
            <RequireAuth allowAnonymous={false}>
              <Suspense fallback={<Loading />}>
                <LinePage />
              </Suspense>
            </RequireAuth>
          </LinesContext.Provider>}
        </Route>
        {/*<Route path="/apps/:appId">*/}
        {/*  {(params) => <LinesContext.Provider value={{...params, serviceId: "app"}}>*/}
        {/*    <RequireAuth allowAnonymous={false}>*/}
        {/*      <Suspense fallback={<Loading />}>*/}
        {/*        <LinePage />*/}
        {/*      </Suspense>*/}
        {/*    </RequireAuth>*/}
        {/*  </LinesContext.Provider>}*/}
        {/*</Route>*/}
        {/*<Route path="/apps/jobs/:appId/:jobId">*/}
        {/*  {(params) => <LinesContext.Provider value={{appId: params.appId, jobId: params.jobId, collectionId: "apps"}}>*/}
        {/*    <RequireAuth allowAnonymous={false}>*/}
        {/*      <Suspense fallback={<Loading />}>*/}
        {/*        <LinePage />*/}
        {/*      </Suspense>*/}
        {/*    </RequireAuth>*/}
        {/*  </LinesContext.Provider>}*/}
        {/*</Route>*/}
        {/*<Route path="/sandbox/:appId">*/}
        {/*  {(params) =>*/}
        {/*    <LinesContext.Provider value={{...params, serviceId: "sandbox", view: "application"}}>*/}
        {/*      <RequireAuth allowAnonymous={false}>*/}
        {/*        <Suspense fallback={<Loading/>}>*/}
        {/*          <LinePage />*/}
        {/*        </Suspense>*/}
        {/*      </RequireAuth>*/}
        {/*    </LinesContext.Provider>}*/}
        {/*</Route>*/}
        {/*<Route path="/sandbox/:appId/jobs/:jobId">*/}
        {/*  {(params) => <LinesContext.Provider value={{appId: params.appId, jobId: params.jobId, serviceId: "sandbox", view: "application"}}>*/}
        {/*    <RequireAuth allowAnonymous={false}>*/}
        {/*      <Suspense fallback={<Loading/>}>*/}
        {/*        <LinePage />*/}
        {/*      </Suspense>*/}
        {/*    </RequireAuth>*/}
        {/*  </LinesContext.Provider>}*/}
        {/*</Route>*/}
        {/*<Route path="/io">*/}
        {/*  <Suspense fallback={<Loading />}>*/}
        {/*    <Io />*/}
        {/*  </Suspense>*/}
        {/*</Route>*/}
        {/*<Route path="/home">*/}
        {/*  <LinesContext.Provider value={{}}>*/}
        {/*    <RequireAuth allowAnonymous={true}>*/}
        {/*      <Suspense fallback={<Loading/>}>*/}
        {/*        <LinePage />*/}
        {/*      </Suspense>*/}
        {/*    </RequireAuth>*/}
        {/*  </LinesContext.Provider>*/}
        {/*</Route>*/}
        <Route path="/claim/:areaCode?">
          <RequireAuth allowAnonymous>
            <Suspense fallback={<Loading/>}>
              <Splash />
            </Suspense>
          </RequireAuth>
        </Route>
        <Route path="/start">
          <LinesContext.Provider
            value={{
              applicationId: "start",
              basePath: `user/${user?.uid}`,
            }}>
            <RequireAuth allowAnonymous={false}>
              <Suspense fallback={<Loading/>}>
                <LineOnboarding />
              </Suspense>
            </RequireAuth>
          </LinesContext.Provider>
        </Route>
        {/*<Route path="/lines">*/}
        {/*  <LinesContext.Provider value={{}}>*/}
        {/*    <RequireAuth allowAnonymous={true}>*/}
        {/*      <Suspense fallback={<Loading/>}>*/}
        {/*        <LinePage />*/}
        {/*      </Suspense>*/}
        {/*    </RequireAuth>*/}
        {/*  </LinesContext.Provider>*/}
        {/*</Route>*/}
        {/*<Route path="/directory">*/}
        {/*  <LinesContext.Provider value={{}}>*/}
        {/*    <RequireAuth allowAnonymous={true}>*/}
        {/*      <Suspense fallback={<Loading/>}>*/}
        {/*        <LinePage />*/}
        {/*      </Suspense>*/}
        {/*    </RequireAuth>*/}
        {/*  </LinesContext.Provider>*/}
        {/*</Route>*/}
        {/*<Route path="/subscribers">*/}
        {/*  <LinesContext.Provider value={{}}>*/}
        {/*    <RequireAuth allowAnonymous={true}>*/}
        {/*      <Suspense fallback={<Loading/>}>*/}
        {/*        <LinePage />*/}
        {/*      </Suspense>*/}
        {/*    </RequireAuth>*/}
        {/*  </LinesContext.Provider>*/}
        {/*</Route>*/}
        {/*<Route path="/subscriptions">*/}
        {/*  <LinesContext.Provider value={{}}>*/}
        {/*    <RequireAuth allowAnonymous={true}>*/}
        {/*      <Suspense fallback={<Loading/>}>*/}
        {/*        <LinePage />*/}
        {/*      </Suspense>*/}
        {/*    </RequireAuth>*/}
        {/*  </LinesContext.Provider>*/}
        {/*</Route>*/}
        {/*<Route path="/assistant">*/}
        {/*  <LinesContext.Provider value={{}}>*/}
        {/*    <RequireAuth allowAnonymous>*/}
        {/*      <Suspense fallback={<Loading/>}>*/}
        {/*        <LinePage />*/}
        {/*      </Suspense>*/}
        {/*    </RequireAuth>*/}
        {/*  </LinesContext.Provider>*/}
        {/*</Route>*/}
        {/*<Route path="/tasks">*/}
        {/*  <LinesContext.Provider value={{}}>*/}
        {/*    <RequireAuth allowAnonymous={false}>*/}
        {/*      <Suspense fallback={<Loading/>}>*/}
        {/*        <LinePage />*/}
        {/*      </Suspense>*/}
        {/*    </RequireAuth>*/}
        {/*  </LinesContext.Provider>*/}
        {/*</Route>*/}
        {/*<Route path="/calls">*/}
        {/*  <LinesContext.Provider value={{}}>*/}
        {/*    <RequireAuth allowAnonymous={false}>*/}
        {/*      <Suspense fallback={<Loading/>}>*/}
        {/*        <LinePage />*/}
        {/*      </Suspense>*/}
        {/*    </RequireAuth>*/}
        {/*  </LinesContext.Provider>*/}
        {/*</Route>*/}
        {/*<Route path="/contacts">*/}
        {/*  <LinesContext.Provider value={{}}>*/}
        {/*    <RequireAuth allowAnonymous>*/}
        {/*      <Suspense fallback={<Loading/>}>*/}
        {/*        <LinePage />*/}
        {/*      </Suspense>*/}
        {/*    </RequireAuth>*/}
        {/*  </LinesContext.Provider>*/}
        {/*</Route>*/}
        {/*<Route path="/onboarding">*/}
        {/*  <LinesContext.Provider value={{}}>*/}
        {/*    <RequireAuth allowAnonymous={false}>*/}
        {/*      <Suspense fallback={<Loading/>}>*/}
        {/*        <ProOnboarding />*/}
        {/*      </Suspense>*/}
        {/*    </RequireAuth>*/}
        {/*  </LinesContext.Provider>*/}
        {/*</Route>*/}
        {/*<Route path="/timeline" key="timeline">*/}
        {/*  <LinesContext.Provider value={{view: "application"}}>*/}
        {/*    <RequireAuth allowAnonymous>*/}
        {/*      <Suspense fallback={<Loading/>}>*/}
        {/*        <LinePage />*/}
        {/*      </Suspense>*/}
        {/*    </RequireAuth>*/}
        {/*  </LinesContext.Provider>*/}
        {/*</Route>*/}
        {/*<Route path="/analyst" key="analyst">*/}
        {/*  <LinesContext.Provider value={{}}>*/}
        {/*    <RequireAuth allowAnonymous>*/}
        {/*      <Suspense fallback={<Loading/>}>*/}
        {/*        <LinePage />*/}
        {/*      </Suspense>*/}
        {/*    </RequireAuth>*/}
        {/*  </LinesContext.Provider>*/}
        {/*</Route>*/}
        {/*<Route path="/datasets/:datasetId" key="datasets">*/}
        {/*  {(params) => <RequireAuth allowAnonymous>*/}
        {/*    <Suspense fallback={<Loading/>}>*/}
        {/*      <LinePage />*/}
        {/*    </Suspense>*/}
        {/*  </RequireAuth>*/}
        {/*  }*/}
        {/*</Route>*/}
        {/*<Route path="/links">*/}
        {/*  <RequireAuth allowAnonymous={false}>*/}
        {/*    <Suspense fallback={<Loading />}>*/}
        {/*      <LinePage />*/}
        {/*    </Suspense>*/}
        {/*  </RequireAuth>*/}
        {/*</Route>*/}
        {/*<Route path="/chat-demo" key="logout">*/}
        {/*  <Suspense fallback={<Loading />}>*/}
        {/*    <ChatDemoManager>*/}
        {/*      <ChatDemo />*/}
        {/*    </ChatDemoManager>*/}
        {/*  </Suspense>*/}
        {/*</Route>*/}
        <Route path="/logout" key="logout">
          <Suspense fallback={<Loading/>}>
            <Logout/>
          </Suspense>
        </Route>
        {/*<Route path="/genesis">*/}
        {/*  <Suspense fallback={<Loading/>}>*/}
        {/*    <Splash />*/}
        {/*  </Suspense>*/}
        {/*</Route>*/}
        {/*<Route path="/verify">*/}
        {/*  <RequireAuth allowAnonymous={false}>*/}
        {/*    <Suspense fallback={<Loading/>}>*/}
        {/*      <Splash initialSlide="signup"/>*/}
        {/*    </Suspense>*/}
        {/*  </RequireAuth>*/}
        {/*</Route>*/}
        {/*<Route path="/subscribe">*/}
        {/*  <RequireAuth allowAnonymous={false}>*/}
        {/*    /!*<RequireVerification>*!/*/}
        {/*      <Suspense fallback={<Loading/>}>*/}
        {/*        <Splash initialSlideKey="subscribe" />*/}
        {/*      </Suspense>*/}
        {/*    /!*</RequireVerification>*!/*/}
        {/*  </RequireAuth>*/}
        {/*</Route>*/}
        <Route path="/pay/:priceId?">
          {(params) => <PayContext.Provider value={[params.priceId]}>
            <RequireAuth allowAnonymous={true}>
              <Suspense fallback={<Loading/>}>
                <Pay />
              </Suspense>
            </RequireAuth>
          </PayContext.Provider>}
        </Route>
        <Route path="/paid">
          <RequireAuth allowAnonymous={true}>
            {/*<RequireVerification>*/}
            <Suspense fallback={<Loading/>}>
              <Paid />
            </Suspense>
            {/*</RequireVerification>*/}
          </RequireAuth>
        </Route>
        {/*<Route path="/subscribed" key="subscribed">*/}
        {/*  <RequireAuth allowAnonymous={false}>*/}
        {/*    /!*<RequireVerification>*!/*/}
        {/*    <Suspense fallback={<Loading/>}>*/}
        {/*      <BetaCountdown/>*/}
        {/*    </Suspense>*/}
        {/*    /!*</RequireVerification>*!/*/}
        {/*  </RequireAuth>*/}
        {/*</Route>*/}
        {/*<Route path="/genesis-access">*/}
        {/*  <RequireAuth allowAnonymous={false}>*/}
        {/*    <Suspense fallback={<Loading/>}>*/}
        {/*      <MemberBenefits/>*/}
        {/*    </Suspense>*/}
        {/*  </RequireAuth>*/}
        {/*</Route>*/}
        {/*<Route path="/genesis-start">*/}
        {/*  <RequireAuth allowAnonymous={false}>*/}
        {/*    <Suspense fallback={<Loading/>}>*/}
        {/*      <Splash initialSlideKey="subscribe" />*/}
        {/*    </Suspense>*/}
        {/*  </RequireAuth>*/}
        {/*</Route>*/}
        <Route path="/email-link">
          <VerifyEmailLink/>
        </Route>
        <Route path="/verify-email">
          <AuthLayoutWrapper hideLinks>
            <AuthEmailPage intent="link" />
          </AuthLayoutWrapper>
        </Route>
        <Route path="/phone/:intent">
          {({intent}) => <AuthLayoutWrapper hideLinks>
            <PhoneAuth intent={intent} />
          </AuthLayoutWrapper>}
        </Route>
        <Route path="/oauth/:integrationId/callback" key="oauth-callback">
          {({integrationId}) => integrationId === "trello-com" ? <TrelloAuthCallback integrationId={integrationId}/> :
            <OauthCallback integrationId={integrationId}/>}
        </Route>
        <Route path="/login" key="login">
          {/*<AuthLayoutWrapper hideLinks>*/}
          {/*  <PhoneAuth intent="sign-in" title="Get Started" />*/}
          {/*</AuthLayoutWrapper>*/}
          <Login providers={["email"]} />
        </Route>
        <Route path="/sign-up" key="sign-up">
          <SignUp providers={["email"]}/>
        </Route>
        <Route path="/account" key="account">
          <RequireAuth allowAnonymous={false}>
            <Suspense fallback={<Loading/>}>
              <AccountPage/>
            </Suspense>
          </RequireAuth>
        </Route>
        <Route path="/timeline-settings" key="timeline-settings">
          <RequireAuth allowAnonymous={false}>
            <Suspense fallback={<Loading/>}>
              <TimelineSettingsPage/>
            </Suspense>
          </RequireAuth>
        </Route>
        {/*<Route path="/about" key="about">*/}
        {/*  <Suspense fallback={<Loading/>}>*/}
        {/*    <About/>*/}
        {/*  </Suspense>*/}
        {/*</Route>*/}
        {/*<Route path="/x-profiler" key="x-profiler">*/}
        {/*  <LinesContext.Provider value={{}}>*/}
        {/*    <RequireAuth allowAnonymous>*/}
        {/*      <Suspense fallback={<Loading/>}>*/}
        {/*        <LinePage />*/}
        {/*      </Suspense>*/}
        {/*    </RequireAuth>*/}
        {/*  </LinesContext.Provider>*/}
        {/*</Route>*/}
        {/*<Route path="/lists/:list">*/}
        {/*  {(params) => <WildcardRoute param={params.list}>*/}
        {/*    <LinesContext.Provider value={{...params, serviceId: params.list}}>*/}
        {/*      <RequireAuth allowAnonymous={false}>*/}
        {/*        <Suspense fallback={<Loading />}>*/}
        {/*          <LinePage />*/}
        {/*        </Suspense>*/}
        {/*      </RequireAuth>*/}
        {/*    </LinesContext.Provider>*/}
        {/*  </WildcardRoute>}*/}
        {/*</Route>*/}
        <Route path="/collections/:collectionId/:applicationId?/:c?/:key?">
          {({c, key, objectId = !!c && !!key && [c, key].join("/"), ...params}) =>
            <WildcardRoute param={params}>
            <LinesContext.Provider
              value={{
                ...params,
                objectId,
                basePath: `user/${user?.uid}`,
                view: "table",
              }}
            >
              <RequireAuth allowAnonymous={false}>
                <Suspense fallback={<Loading />}>
                  <LinePage />
                </Suspense>
              </RequireAuth>
            </LinesContext.Provider>
          </WildcardRoute>}
        </Route>
      </Switch>
      <VideoModal/>
      {/*<VoiceDrawer />*/}
    </FeedLayout>
    </SourcesContext.Provider>
  </UserContext.Provider>;
};
export default App;
